var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{ref:"numberGrow",attrs:{"data-time":_vm.time}},[_vm._v("0")])])
}
var staticRenderFns = []

export { render, staticRenderFns }